import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import PremServer from '../components/PremServer';
import LocalServer from '../components/LocalServer';
import EditServer from '../pages/EditServer';
import { useGetMyServersQuery } from '../RTK/ApiRequests';

const MyServers = ({ username }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [isEdit, setIsEdit] = useState(false);
  const [editInfo, setEditInfo] = useState({});

  const { data, isLoading, isError } = useGetMyServersQuery({
    username,
    pages: currentPage,
  });

  const totalPages = data?.totalPages;

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const editServer = (serverInfo) => {
    setIsEdit(true);
    setEditInfo(serverInfo);
  };

  return (
    <MyServerWrapper>
      {!isEdit ? (
        <>
          <NavLink to={'/servers/add-server'}>
            <button id='addServer'>Add Server</button>
          </NavLink>
          <h4 style={{ textAlign: 'center', fontSize: '2rem' }}>Your current votes: {data?.totalVotesOfUser}</h4>
          <ServersList>
            {data?.servers?.map((currElem, index) => {
              if (currElem.isPremium) {
                return <PremServer key={index} isEdit={true} editServer={editServer} serverInfo={currElem} />;
              }
            })}
            {data?.servers?.map((currElem, index) => {
              if (!currElem.isPremium) {
                return <LocalServer key={index} isEdit={true} editServer={editServer} serverInfo={currElem} index={index} />;
              }
            })}
          </ServersList>
          <Pagination>
            <button onClick={handlePreviousPage} disabled={currentPage === 1}>
              Previous
            </button>
            <span>{currentPage} / {totalPages}</span>
            <button onClick={handleNextPage} disabled={currentPage === totalPages}>
              Next
            </button>
          </Pagination>
        </>
      ) : (
        <EditServer editInfo={editInfo} />
      )}
    </MyServerWrapper>
  );
};

const MyServerWrapper = styled.section`
  min-height: 100vh;
  padding-bottom: 5rem;
  #addServer {
    background-color: #58678c;
    display: block;
    border: none;
    color: #fff;
    text-align: center;
    font-weight: 600;
    font-size: 20px;
    padding: 1rem;
    text-transform: uppercase;
    cursor: pointer;
    width: 50%;
    margin: 3rem auto;
  }
`;

const ServersList = styled.section`
  display: flex;
  gap: 3rem;
  align-items: center;
  flex-direction: column;
  margin-top: 5rem;
  margin-bottom: 5rem;
`;

const Pagination = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 5rem;

  button {
    background-color: #3ba61c;
    color: #fff;
    padding: 8px 16px;
    border: none;
    margin: 0 5px;
    cursor: pointer;
    outline: none;
    border-radius: 5px;
    font-size: 16px;

    &:disabled {
      background-color: #ccc;
      cursor: not-allowed;
    }
  }
`;

export default MyServers;